<template>
  <b-modal
    :title="`${title}`"
    v-model="showModal"
    hide-footer
    centered
  >
    <form data-vv-scope="folder-form" @submit.prevent="save" autocomplete="autocomplete_off_name">
      <div class="row">
        <div class="col-md-12">
          <vs-input
            name="name"
            data-cy="folder-name"
            class="w-100"
            label="Nombre para carpeta"
            autocomplete="autocomplete_off_name"
            data-vv-as="Nombre para carpeta"
            v-model="formValues.name"
            v-validate="'required|max:255'"
            val-icon-danger="error_outline"
            :danger="errors.has('folder-form.name')"
            :danger-text="errors.first('folder-form.name')"
            val-icon-success="check_circle"
            :success="!errors.has('folder-form.name') && formValues.name.length > 0"
          />
        </div>
      </div>
      <div class="m-top-20 d-flex justify-end">
        <vs-button
          class="mt-5 ml-3"
          v-on:click="save"
          color="primary"
          type="border"
          data-cy="save"
        >
          {{ buttonLabel }}
          <span v-show="loading" class="spinner-border spinner-border-sm text-white" />
        </vs-button>
      </div>
    </form>
  </b-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'FolderFormView',
  props: {
    isEdit: {
      type: Boolean,
      required: false,
      default: () => false
    }
  },
  data() {
    return {
      formValues: {
        name: '',
        parentFolder: ''
      },
      fullpathId: null,
      loading: false,
      selectedFile: false,
      filesStack: [],
      regexValidation: /.*/
    };
  },
  mounted() {
    if (this.getSelectedFolderId) {
      const treeFolder = this.getTreeElements[this.getSelectedFolderId];
      this.fullpathId = `${treeFolder.fullpathId}/${treeFolder.carpetaId}`;
    }
    if (this.isEdit) {
      this.formValues.name = this.getSelectedElement.name;
      this.formValues.parentFolder = this.getSelectedElement.parentFolder;
    }
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedRepositoryId',
      'getSelectedFolderId',
      'getSelectedElement',
      'getTreeElements',
      'getRepositories'
    ]),
    showModal: {
      get() {
        return this.modalName === 'folderFormED';
      },
      set() {
        this.closeModal();
      }
    },
    title() {
      let response = '';
      const prep = this.isEdit ? 'Editar' : 'Agregar carpeta a';
      if (this.getSelectedFolderId) {
        response = `${prep} ${this.getTreeElements[this.getSelectedFolderId].nombre}`;
      }
      if (this.getSelectedRepositoryId) {
        response = `${prep} ${this.getRepositories[this.getSelectedRepositoryId].nombreRepositorio}`;
      }
      if (this.getSelectedElement && this.isEdit) {
        response = `${prep} ${this.getSelectedElement.name}`;
      }
      return response;
    },
    repositoryId() {
      let response = '';
      if (this.getSelectedFolderId) {
        response = this.getTreeElements[this.getSelectedFolderId].repositoryId;
      }
      if (this.getSelectedRepositoryId) {
        response = this.getSelectedRepositoryId;
      }
      return response;
    },
    buttonLabel() {
      if (this.isEdit) {
        return 'Editar';
      }
      return 'Agregar';
    }
  },
  methods: {
    ...mapActions('DocManagement', [
      'addFolder',
      'updateFolder'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    async save() {
      if (this.loading) {
        return;
      }
      const formCheck = await this.$validator.validateAll('folder-form');
      if (formCheck) {
        this.loading = true;
        if (this.isEdit) {
          const { name } = this.getSelectedElement;
          await this.updateFolder({
            name: this.formValues.name,
            parentFolder: this.getSelectedElement.parentFolder,
            folderId: this.getSelectedElement.id,
            repositoryId: this.repositoryId,
          });
          this.$bvToast.toast(
            'La carpeta ha sido actualizada correctamente!',
            {
              title: `Editar ${name}`,
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 15000
            }
          );
        } else {
          await this.addFolder({
            to: this.fullpathId ? this.fullpathId : '/',
            repositoryId: this.repositoryId,
            name: this.formValues.name,
            parentFolder: this.getSelectedFolderId
          });
          this.$bvToast.toast(
            'La carpeta ha sido creada correctamente!',
            {
              title: this.title,
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 15000
            }
          );
        }
        this.cleanForm();
        this.loading = false;
      }
    },
    cleanForm() {
      this.formValues = {
        name: ''
      };
    }
  }
};
</script>
<style scoped>
</style>
